import { Box, Button } from "@mui/material";
import { Link } from "../types";
import React from "react";

type ModalContentProps = {
	title?: string;
	subtitle?: string;
	image?: string;
	acf?: any;
	content?: JSX.Element;
	button?: JSX.Element;
};

const additionalButtons = ( acf?: any ) => {
	const additionalButtonElements: JSX.Element[] = [];

	if ( acf
		&& acf.additional_buttons
		&& acf.additional_buttons.length
	) {
		acf.additional_buttons.forEach( ( item: {link: Link} ) => {
			if ( item
				&& item.link
				&& item.link.url
				&& item.link.title
			) {
				additionalButtonElements.push( <div><Button
					variant="contained"
					color="secondary"
					style={{ color: "white" }}
					onClick={() => window.open(item?.link?.url, item?.link?.target)}
				>
					{ item.link.title }
				</Button></div> );
			}
		} );
	}
	return (<>{ additionalButtonElements }</>);
};

const ModalContent = ({
	title,
	subtitle,
	image,
	acf,
	content,
	button,
}: ModalContentProps) => {
	return (
		<div className="flex flex-wrap flex-col-reverse xl:flex-row gap-[50px]">
			<div className="flex flex-col w-[500px] max-w-full">
				{title && (
					<h2
						className="text-2xl font-semibold"
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				)}
				{subtitle && (
					<h3
						className="text-xl font-semibold"
						dangerouslySetInnerHTML={{ __html: subtitle }}
					/>
				)}
				<Box
					className="whitespace-pre-line"
					sx={{
						"& br": {
							display: "none",
						},
					}}
				>
					{content}
				</Box>
			</div>
			<div className="flex flex-col items-end gap-[30px]">
				{image ? (
					<img
						className="w-full xl:w-[406px] h-[285px] max-h-full max-w-full"
						src={image}
						alt={title}
					/>
				) : (
					<div className="w-full xl:w-[406px] h-[285px] max-h-full max-w-full" />
				)}
				<div>{button}</div>
				{ additionalButtons( acf ) }
			</div>
		</div>
	);
};

export default ModalContent;
